import type {
  PostRegulatoryListFilterApiResponse,
  PostRegulatoryListFilterResponse,
} from "@interface/regulatoryList.interface";

export const adaptRegulatoryListData = (
  response: PostRegulatoryListFilterApiResponse,
): PostRegulatoryListFilterResponse => ({
  page: response.page,
  size: response.size,
  totalPages: response.totalPages,
  total: response.total,
  data: response.data,
});
